<template>
	<form class="form" @submit.prevent="submit" novalidate>
		<ValidationAlert :error-list="errors.collect('server')"></ValidationAlert>

		<fieldset class="form__group">
			<legend>The following {{ imported.length > 1 ? 'users' : 'user' }} will be added to the {{ member ? member.name : 'Unknown company' }}
				profile
			</legend>

			<ul class="imported">
				<li v-for="user in imported" class="imported__user">
					<span class="user__name">{{ user.name }}</span>
					<span class="user__email">{{ user.email }}</span>
				</li>
			</ul>

			<div class="form__group form__group--submit">
				<button class="btn" @click.prevent="back" v-wait:disabled='["submit"]'>Back</button>
				<button class="btn btn--primary" v-wait:disabled='["submit"]'>Confirm</button>
			</div>
		</fieldset>
	</form>
</template>

<script>
	import API from './../../../api';
	import ValidationAlert from '../../ValidationAlert';
	import UserCreateFormStep from './UserCreateFormStep';

	export default {
		name: 'UserCreateFormStep3',
		components: {
			ValidationAlert,
		},
		mixins: [UserCreateFormStep],
		data() {
			return {
				formData: {
					member: null,
					preview: false,
					csv: null,
					zip: null,
					firstName: null,
					lastName: null,
					position: null,
					specialisms: [],
					avatar: null,
					email: null,
					office: null,
				},
				imported: [],
			}
		},
        computed: {
		    member() {
		        console.log(this.formData);
                return this.$store.getters['selectCache/getMember'](this.formData.member);
            }
        },
		methods: {
			save() {
				if(this.savedFormData.multiple) {
					return API.importUsers(this.formData).then(response => {
						this.$router.push({ name: 'users' });
					});
				} else {
					return API.createUser(this.formData).then(response => {
						this.$router.push({ name: 'users' });
					});
				}
			}
		},
		created() {
			this.imported = this.savedFormData.imported;
			this.formData.preview = false;
		},
	}
</script>

<style lang="scss" scoped>
	@import '~reflex-grid/scss/includes/variables';
	@import '~reflex-grid/scss/includes/mixins';
	@import '~@/theme/_variables.scss';
	@import '~@/mixins/_class.scss';
	@import '~@/theme/_extenables.scss';

	.imported {
		list-style: none;
		padding: 0;
		margin: 0 0 3rem;

		.imported__user {
			padding-bottom: 0.5rem;
			border-bottom: 0.1rem solid $secondary;
			margin-bottom: 0.5rem;
			@include display-flex;
			@include align-items(center);

			.user__avatar {
				margin-right: 1rem;
			}

			.user__name {
				text-overflow: ellipsis;
				min-width: 4rem;
				@include flex(0, 1, auto);
			}

			.user__email {
				margin-left: auto;
			}
		}
	}
</style>
